import api from './api';

const auditLogService = {
  // Get all audit logs with filtering and pagination
  getAllAuditLogs: async (params = {}) => {
    const response = await api.get('/audit-logs', { params });
    return response.data;
  },

  // Get audit log by ID
  getAuditLogById: async (id) => {
    const response = await api.get(`/audit-logs/${id}`);
    return response.data;
  },

  // Get audit logs by entity
  getAuditLogsByEntity: async (entityType, entityId, params = {}) => {
    const response = await api.get(`/audit-logs/entity/${entityType}/${entityId}`, { params });
    return response.data;
  },

  // Get audit logs by user
  getAuditLogsByUser: async (userId, params = {}) => {
    const response = await api.get(`/audit-logs/user/${userId}`, { params });
    return response.data;
  },

  // Get audit log statistics
  getAuditLogStats: async (params = {}) => {
    const response = await api.get('/audit-logs/stats', { params });
    return response.data;
  },

  // Export audit logs
  exportAuditLogs: async (params = {}) => {
    const response = await api.get('/audit-logs/export', { params });
    return response.data;
  },

  // Create audit log (typically used internally)
  createAuditLog: async (data) => {
    const response = await api.post('/audit-logs', data);
    return response.data;
  }
};

export default auditLogService;


